import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { Cfop, SearchCfopsQuery } from './Cfop.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/cfops`;

export async function searchCfops(
  params?: SearchCfopsQuery,
): Promise<PageResult<Cfop>> {
  const result = (await api.get(`${CONTROLLER_URL}/search`, params)) as unknown;

  return result as PageResult<Cfop>;
}

export async function cfopDetail(id: number): Promise<Cfop> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Cfop;
}
